import { Injectable } from '@angular/core';

import { GroupsOfGroup } from '@era/security-sdk';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, mergeMap, tap } from 'rxjs/operators';
import { GroupsOfGroupStoreActions, GroupsOfGroupStoreSelectors } from '../groups-of-group';
import { AclRouterStoreSelectors, RouterStoreStates } from '../router';

@Injectable()
export class GroupsOfGroupResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly groupsOfGroupStore: Store<GroupsOfGroup>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(AclRouterStoreSelectors.selectCurrentAclId).pipe(
      mergeMap((x) =>
        this.groupsOfGroupStore.select(GroupsOfGroupStoreSelectors.selectParentGroups(x)).pipe(
          tap((y) => {
            if (y.length < 1) {
              this.groupsOfGroupStore.dispatch(
                GroupsOfGroupStoreActions.GroupsOfGroupResolverActions.userGroupsRequested({ groupId: x })
              );
            }
          })
        )
      ),
      map(() => true),
      first()
    );
  }
}
